/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress,
  Card,
  CardContent,
} from "@mui/material";
import { api } from "../api";
import { useNavigate, useLocation } from "react-router-dom";

export default function PublicEmailSignup() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const signupMode = location.state?.signupMode || "trial";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await api.post("/auth/send-otp", { 
        email,
      signup_mode: signupMode,
     });
      navigate("/signup/verify", { state: { email, signupMode } });
    } catch (err) {
      setError(
        err.response?.data?.detail || err.message || "Failed to send OTP."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 400, mx: "auto", mt: 8 }}>
      <Card>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Start Your Free Trial
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            No credit card required. Enter your email to begin.
          </Typography>

          {error && <Alert severity="error">{error}</Alert>}

          <form onSubmit={handleSubmit}>
            <TextField
              label="Email Address"
              type="email"
              fullWidth
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <Box mt={2}>
              <Button
                variant="contained"
                type="submit"
                color="primary"
                disabled={loading}
                fullWidth
              >
                {loading ? <CircularProgress size={24} /> : "Send OTP"}
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}